package components

import androidx.compose.runtime.Composable
import net.sergeych.ugdx.shared.Currency
import frontend.pages.ExpiresDuration
import frontend.pages.TransferType
import org.jetbrains.compose.web.attributes.name
import org.jetbrains.compose.web.attributes.selected
import org.jetbrains.compose.web.dom.*

class ExpiresAtSelectAttrsBuilder {
    var onChange: (value: ExpiresDuration?) -> Unit = {}
    var label: @Composable() () -> Unit = {}
    var options: List<ExpiresDuration> = ExpiresDuration.values().toList()

    fun onChange(handler: (value: ExpiresDuration?) -> Unit) { onChange = handler }
    fun label(l: @Composable() () -> Unit) { label = l }
}

@Composable
fun ExpiresAtSelect(
    id: String,
    selected: ExpiresDuration?,
    attrs: ExpiresAtSelectAttrsBuilder.() -> Unit = {}
) {
    val builder = ExpiresAtSelectAttrsBuilder()
    attrs.invoke(builder)

    Div() {
        Select(attrs = {
            id(id)
            name("select")
            classes("mt-1", "block", "w-full", "pl-3", "pr-10", "py-1", "text-base", "border-gray-300", "focus:outline-none", "focus:ring-indigo-500", "focus:border-indigo-500", "sm:text-sm", "rounded-md")
            onChange {
                val id = it.value
                val type = builder.options.find { it.toString() == id }
                builder.onChange(type)
            }
        }) {
            builder.options.forEach {
                val option = it

                Option(option.toString(), attrs = {
                    if (selected?.toString() == option.toString()) selected()
                }) { Text("Expires in ${option.label}") }
            }
        }
    }
}